import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Table,
  Form,
  Input,
  InputNumber,
  Modal,
  message,
  DatePicker,
  Select,
} from "antd";
import RenderTxt from "@components/renderTxt";
import SystemApi from "@api/sys";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import SearchForm from "@components/SearchForm";
import moment from "moment";
import stationApi from "@api/station";

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
const Outbound = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [loading, setLoading] = useState(false);
  const [storePartList, setStorePartList] = useState([]);
  const [partInfo, setPartInfo] = useState({});
  const [storeList, setStoreList] = useState([]);
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const [tableSource, setTableSource] = useState({});
  const [inputList] = useState([
    {
      label: "经办人:",
      name: "handleName",
      message: "请输入经办人",
      span: 6,
      labelCol: 6,
    },
    {
      label: "备品备件名称:",
      name: "partName",
      message: "请输入备品备件名称",
      span: 6,
      labelCol: 6,
    },
    {
      label: "仓库名称:",
      name: "storeName",
      message: "请输入仓库名称",
      span: 6,
      labelCol: 6,
    },
  ]);
  const [dateSearch] = useState([
    {
      label: "出库时间:",
      name: "time",
      span: 6,
      labelCol: 6,
      tag: "rangePicker",
    },
  ]);
  const [cascaderLs, setCascaderLs] = useState([
    {
      label: "设备",
      name: "deviceId",
      message: "请选择设备",
      span: 6,
      labelCol: 6,
      options: [],
    },
  ]);

  const columns = [
    {
      title: "经办人",
      dataIndex: "handleName",
      align: "center",
      key: "handleName",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "出库数量",
      dataIndex: "outNum",
      align: "center",
      key: "outNum",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "备品备件",
      dataIndex: "partName",
      align: "center",
      key: "partName",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "仓库",
      dataIndex: "storeName",
      align: "center",
      key: "storeName",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "出库时间",
      dataIndex: "outTime",
      align: "center",
      key: "outTime",
      render: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
    },
    // {
    //   title: "操作",
    //   dataIndex: "action",
    //   align: "center",
    //   key: "action",
    //   render: (text, obj) => {
    //     return (
    //       <>
    //         <Button type="primary" onClick={() => editRecord(obj)}>
    //           编辑
    //         </Button>
    //         <Button
    //           style={{ marginLeft: 8 }}
    //           type="primary"
    //           onClick={() => delRecord(obj.id)}
    //           danger
    //         >
    //           删除
    //         </Button>
    //       </>
    //     );
    //   },
    // },
  ];

  useEffect(() => {
    getStoreAllByStation();
    getDeviceByStationId();
  }, []);

  useEffect(() => {
    getListPages();
  }, [searchParams]);

  const getDeviceByStationId = () => {
    stationApi.getDeviceByStationId({ stationId }).then((res) => {
      if (res.status !== "0") return;
      const ls = getTreeData(res.data);
      const index = cascaderLs.findIndex((item) => item.name === "deviceId");
      if (index > -1) {
        cascaderLs[index].options = ls;
        setCascaderLs([...cascaderLs]);
      }
    });
  };

  const getTreeData = (data) => {
    return data.map((item) => {
      const value = item.deviceId ? item.deviceId : item.id;
      return {
        ...item,
        id: value,
        label: item.itemName,
        value,
        children: item.child.length ? getTreeData(item.child) : undefined,
        child: undefined,
      };
    });
  };

  const getStoreAllByStation = () => {
    SystemApi.storeAllByStation({ stationId }).then((res) => {
      if (res.status !== "0") return;
      setStoreList(res.data);
    });
  };

  const getListPages = () => {
    setLoading(true);
    SystemApi.storeReceiptOutList(searchParams).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { data } = res.data;
      data.map((item) => {
        item.key = item.id;
      });
      setTableSource(res.data);
    });
  };

  const delRecord = (id) => {
    Modal.confirm({
      onOk: () => {
        SystemApi.storeReceiptOutRemove({ id }).then((res) => {
          if (res.status !== "0") return;
          message.success("删除成功");
          if (tableSource.data.length == 1 && tableSource.pageNum > 1) {
            searchParams({
              ...searchParams,
              pageNum: searchParams.pageNum - 1,
            });
          } else {
            getListPages();
          }
        });
      },
      title: "请确认",
      icon: <ExclamationCircleOutlined />,
      content: "是否删除",
      okText: "确认",
      cancelText: "取消",
    });
  };

  const editRecord = (obj) => {
    setVisible(true);
    setEditId(obj.id);
    form.setFieldsValue({ ...obj });
  };

  const cancel = () => {
    setVisible(false);
    form.resetFields();
    setEditId(null);
  };

  const save = () => {
    form.validateFields().then((values) => {
      const params = {
        ...values,
        outTimeStr: values.outTimeStr.format("YYYY-MM-DD HH:mm:ss"),
      };
      if (editId) {
        setConfirmLoading(true);
        SystemApi.storeReceiptOutUpdate({ ...params, id: editId }).then(
          (res) => {
            setConfirmLoading(false);
            if (res.status !== "0") return;
            message.success("修改成功");
            cancel();
            getListPages();
          }
        );
      } else {
        setConfirmLoading(true);
        SystemApi.storeReceiptOutInsert(params).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          if (res.data == true) {
            message.warning(
              `新增成功, 库存数量到达阀值(${partInfo.thresholdNum})提醒`
            );
          } else {
            message.success("新增成功");
          }

          cancel();
          getListPages();
        });
      }
    });
  };

  const changeStore = (id) => {
    SystemApi.listByStoreId({ id }).then((res) => {
      if (res.status !== "0") return;
      setStorePartList(res.data);
      form.setFieldsValue({ partId: undefined });
    });
  };

  const changePartId = (value) => {
    setPartInfo(storePartList.find((item) => item.id === value));
  };

  const handleTableChange = (pagination) => {
    const params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  const search = (values) => {
    setSearchParams({
      ...searchParams,
      ...values,
      pageNum: 1,
      pageSize: 10,
      startTime: values.time
        ? values.time[0].format("YYYY-MM-DD") + " 00:00:00"
        : undefined,
      endTime: values.time
        ? values.time[1].format("YYYY-MM-DD") + " 23:59:59"
        : undefined,
      deviceId: values.deviceId
        ? values.deviceId[values.deviceId.length - 1]
        : undefined,
      time: undefined,
    });
  };

  return (
    <div style={{ padding: 20 }}>
      <SearchForm
        span={6}
        inputList={inputList}
        onSearch={search}
        dateSearch={dateSearch}
        cascaderLs={cascaderLs}
      />
      <Button
        type="primary"
        style={{ marginBottom: "10px" }}
        onClick={() => setVisible(true)}
      >
        新增
      </Button>
      <Table
        loading={loading}
        columns={columns}
        dataSource={tableSource.data}
        pagination={{
          current: tableSource.pageNum == 0 ? 1 : tableSource.pageNum,
          pageSize: tableSource.pageSize,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total) => `共${total}条数据`,
          total: tableSource.total * 1,
        }}
        onChange={handleTableChange}
      />
      {visible && (
        <Modal
          title={editId ? "编辑" : "新增"}
          open={visible}
          onCancel={cancel}
          onOk={save}
          confirmLoading={confirmLoading}
        >
          <Form {...layout} form={form}>
            <Form.Item
              label="仓库"
              name="storeId"
              rules={[{ required: true, message: "请选择仓库!" }]}
            >
              <Select placeholder="请选择仓库" onChange={changeStore}>
                {storeList.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="备品备件"
              name="partId"
              rules={[{ required: true, message: "请选择备品备件!" }]}
            >
              <Select placeholder="请选择备品备件" onChange={changePartId}>
                {storePartList.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="经办人"
              name="handleName"
              rules={[{ required: true, message: "请输入经办人!" }]}
            >
              <Input placeholder="请输入经办人" />
            </Form.Item>
            <Form.Item
              label="出库数量"
              name="outNum"
              rules={[
                {
                  required: true,
                  message: "请输入出库数量!",
                },
                {
                  validator(_, value) {
                    if (value <= partInfo.num) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      `出库数量不能大于库存数量${partInfo.num}`
                    );
                  },
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder="请输入出库数量"
              />
            </Form.Item>
            <Form.Item
              label="出库时间"
              name="outTimeStr"
              rules={[{ required: true, message: "请选择出库时间!" }]}
            >
              <DatePicker placeholder="请选择出库时间" />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Outbound);
